// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f35d517b","455":"82695b3a","977":"f2d00c2f"}[chunkId] + ".chunk.js";
};